import service from '@/services/linkProducts';

export default {
  getGroups: ({ commit, dispatch }) => {
    commit('setLoadingGroups', true);
    return service.getProductGroups().then(res => {
      if (res.data.groups.length > 0) {
        for (const group of res.data.groups) {
          if (group.loading) {
            setTimeout(() => dispatch('getGroups'), 4000);
            break;
          } else {
            commit('setGroups', res.data.groups);
            commit('setLoadingGroups', false);
            commit('setTotalItems', res.data.totalItems);
          }
        }
      } else {
        commit('setGroups', res.data.groups);
        commit('setLoadingGroups', false);
        commit('setTotalItems', res.data.totalItems);
      }
    });
  },
  createGroup: ({ dispatch }, payload) => {
    return service.createGroup(payload).then(() => {
      dispatch('getGroups');
    });
  },
  setProductSearch: ({ commit }, payload) => {
    commit('setProductSearch', payload);
  },
  searchProducts: ({ commit, state }) => {
    commit('setProductSearchLoading', true);
    return service.searchProduct(state.productSearch.query).then(res => {
      commit('setProductSearch', {
        selected: state.productSearch.selected,
        items: res.data.data,
        loading: false,
      });
    });
  },
  loadGroupProducts: ({ commit }, payload) => {
    commit('setLoadingProducts', true);
    return service.getProductGroup(payload).then(res => {
      commit('setProductList', res.data.products);
      commit('setLoadingProducts', false);
    });
  },
  deleteGroup: ({ dispatch }, payload) => {
    return service.deleteGroup(payload).then(() => {
      dispatch('getGroups');
    });
  },
  editGroup: ({ dispatch }, payload) => {
    return service.editGroup(payload).then(() => {
      dispatch('getGroups');
    });
  },
  editGroupName: ({ dispatch }, payload) => {
    return service.editGroupName(payload).then(() => {
      dispatch('getGroups');
    });
  },

  removeProduct: ({ dispatch }, payload) => {
    return service.removeFromGroup(payload).then(() => {
      dispatch('getGroups');
    });
  },
  addToGroup: ({ dispatch }, payload) => {
    return service.addToGroup(payload.currentGroup, payload.productId).then(() => {
      dispatch('getGroups');
    });
  },
};
